import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { withTranslation } from 'react-i18next'
const SearchContainer = props => {
  const { t } = props
  return (
    <div className="text-center">
      <FontAwesomeIcon className="IconSearch" icon={faSearch} />
      <p>{t('No existen resultados')}</p>
    </div>
  )
}

export default withTranslation()(SearchContainer)
